import { bootstrapApplication } from "@angular/platform-browser";
import { App } from "./app/app";
import { appConfig } from "./app/app.config";
import { logger } from "./app/core/utils/logger";

bootstrapApplication(App, appConfig).catch((err) => logger.error(err));
